import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive,  watch } from 'vue';
import CInput from '@/components/shared/CInput.vue';
import { ProductBase } from '@/typings/customilyElements/productBase';
import CSelect,  { type CSelectItem, type Primitive } from '@/components/shared/CSelect';
import CButton from '@/components/shared/CButton';



export default /*#__PURE__*/_defineComponent({
  __name: 'ProductBaseResume',
  props: {
    productBase: null
  },
  emits: ["edit-production-file", "edit-preview", "color-variant-selected", "generate-color-images", "save-product-base"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'edit-production-file'): void;
    (e: 'edit-preview'): void;
    (e: 'color-variant-selected', position: number): void;
    (e: 'generate-color-images'): void;
    (e: 'save-product-base'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    productBase?: ProductBase;
};





const model = reactive({
    fileWidth: 0,
    fileHeight: 0,
    unit: '',
    dpi: 0,
    format: '',
    variants: [] as { name: string, values: string[], isColorVariant: boolean, selected?: string }[] 
});

const hasColorVariant = computed(() => {
    return props.productBase?.variants?.some(v => v.isColorVariant) ?? false;
});

const initModel = (productBase: ProductBase) => {
    model.fileWidth = productBase.fileWidth;
    model.fileHeight = productBase.fileHeight;
    model.unit = productBase.unit;
    model.dpi = productBase.dpi;
    model.format = productBase.format;
    model.variants = productBase.variants.map(v => {
    const hasValues = v.values?.length > 0;
        return {
            name: v.name,
            values: v.values ?? [],
            isColorVariant: v.isColorVariant || false,
            selected: hasValues ? v.values[0] : undefined
        };
    });
};

watch(() => props.productBase, (element) => {
    if (!element) {
        return;
    }
    initModel(element);
}, { immediate: true, deep: true  });

const editProductionFile = () => {
    emit('edit-production-file');
};

const editPreview = () => {
    emit('edit-preview');
};

const generateColorImages = () => {
    emit('generate-color-images');
};

const save = () => {
    emit('save-product-base');
};

const selectVariant = (isColorVariant: boolean, item: CSelectItem<Primitive> | Primitive | undefined) => {
    if (!isColorVariant) {
        return;
    }

    if (!item || typeof item !== "object") {
        return;
    }
    const position = (item as CSelectItem<string, {position: number}>)?.object?.position ?? 1;
    emit('color-variant-selected', position);
};


return { __sfc: true,props, emit, model, hasColorVariant, initModel, editProductionFile, editPreview, generateColorImages, save, selectVariant, CInput, CSelect, CButton }
}

})